import type { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { getSession } from '../../api'
import { signSessionContract } from '../../api/rootstech/contracts'

interface Agreement {
  creator?: {
    id: string
  }
  date: number
}

interface GetAgreementParams {
  agreements?: Agreement[]
  creatorId: string
}

interface RefreshAgreementParams {
  creatorId: string
  contentLocale: string
  sessionId: string
  client: ApolloClient<NormalizedCacheObject>
  isDashboard: boolean
}

export const getAgreement = ({ agreements, creatorId }: GetAgreementParams): Agreement | undefined => {
  // agreements = [{ creator: { id: '0000017c-7cd9-d8da-a9fd-fedd9f450000' }, date: 1634247618514 }]
  return agreements?.find((agreement) => creatorId === agreement?.creator?.id)
}

export const refreshAgreement = async ({
  creatorId,
  contentLocale,
  ...props
}: RefreshAgreementParams): Promise<Agreement | undefined> => {
  const session = await getSession({ locale: contentLocale, ...props })
  const agreements = session?.agreements || [] // [{ creator: { id: '0000017c-7cd9-d8da-a9fd-fedd9f450000' }, date: 1634247618514 }] // retValue.agreements
  return getAgreement({ agreements, creatorId })
}

/**
 * Generates the contract URL for a given session and user
 */
export async function getContractUrl({
  sessionId,
  locale,
  cisId,
}: {
  sessionId: string
  locale: string
  cisId?: string
}): Promise<string> {
  const data = await signSessionContract({ sessionId, locale, cisId })
  const url = new URL(data.headers.location)
  return `/rootstech/contracts/presenter-agreement${url.search}`
}
